<template>
  <div class="container">
    <!-- Modal -->
    <div class="modal fade" id="modalHistoricoNotificacoes" role="dialog">
      <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">

          <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal">&times;</button>
              <h1 class="modal-title">Histórico de Notificações</h1>
          </div>
          <div class="modal-body alert-body">

            <div class="filtro-historico-notificacoes">
              <b-form-group
                label="Filtrar pesquisa"
                label-for="filterInput"
                align="center"
              >
                <b-input-group>
                  <b-form-input
                  class="text-align-center"
                    v-model="filter"
                    type="search"
                    id="filterInput"
                    placeholder="Pesquise por qualquer palavra chave"
                  >
                  </b-form-input>
                      <b-button :disabled="!filter" @click="filter = ''" class="limparPesquisaBotao" variant="primary">Limpar pesquisa</b-button>
                </b-input-group>
              </b-form-group>
            </div>
            <div>
              <b-table 
                striped hover
                :items="historicoNotificacoes"
                :filter="filter"
                :fields="fieldsHistorico">
              </b-table>
            </div>
          </div> 
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">Fechar</button>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['consultaHistoricoNotificacoes'],
  data () {
    return {
      filter: null,
      historicoNotificacoes: [],
      env: process.env,
      fieldsHistorico: [
        { key: 'notificacao_id', label: 'Notificação Id' },
        { key: 'email', label: 'Email' },
        { key: 'acao', label: 'Ação' },
        { key: 'status_resposta', label: 'Status' },
        { key: 'uf', label: 'Uf' },
        { key: 'tipo_imovel_servico', label: 'Contrato' },
        { key: 'created_at', label: 'Data de criação' }
      ]
    }
  },
  watch: {
    consultaHistoricoNotificacoes: function () {
      this.getEvidencias(this.consultaHistoricoNotificacoes)
    }
  },
  methods: {
    getEvidencias (parametros) {
      let vm = this
      this.$axios.post(`${this.env.FINANCEIRO.NOTIFICACAO}/gethistoriconotificacoes`, parametros, {
        headers: {
          'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`
        }
      }).then(function (response) {
        vm.historicoNotificacoes = response.data
      })
    }
  }
}
</script>
<style scoped src="../css/modalHistoricoNotificacao.css"></style>




// WEBPACK FOOTER //
// ModalHistoricoNotificacao.vue?c22fcfa0